import React, { useEffect, useState } from 'react';
import { Avatar, Switch, Form, Input } from 'antd';
import { useSelector } from 'react-redux';
import { TurnOnOffMaintenanceApi, TurnOnOffMobileNoOfIBTreeApi, GetMaintenanceStatusApi, GetContactStatusApi, UpdateParentVisibilityApi, ForgetOtp2FAApi,Request2faChangeApi } from '../../api/request/header/maintenance';
import toast from 'react-hot-toast';
import ModalComponent from "../../components/global/modal/ModalComponent";
import LoadableButton from "../../components/buttons/LoadableButton"


export default function Profile({ isAdmin }) {
    const [formotp] = Form.useForm()
    const { userDetails } = useSelector(state => state.user);
    let isSalesManager = userDetails?.roleId === 6;
    const [checked, setChecked] = useState(false);
    const [contactChecked, setContactChecked] = useState(false);
    const [parentChecked, setParentChecked] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen2FAModal, setIsOpen2FAModal] = useState(false);
    const [FormData, setFormData] = useState({ otp: "" });
    const [verifyWithOpt, setVerifyWithOpt] = useState(() => {
        const stored = localStorage.getItem("verifyWithOpt");
        return stored ? JSON.parse(stored) : false;
    });
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(0);
    const [intervalId, setIntervalId] = useState(null);

    const formatTime = (timer) => {
        const minutes = Math.floor(timer / 60);
        const remainingSeconds = timer % 60;
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');

        return `${formattedMinutes}:${formattedSeconds}`;
    };

    const handleChange = async (checked) => {
        try {
            const { data } = await TurnOnOffMaintenanceApi(new URLSearchParams({ isEnabled: checked }).toString());
            if (data?.success) {
                setChecked(checked);
                toast.success(data?.message);
            }
        } catch (error) {
            if (error?.response?.data?.error?.messag) {
                toast.error(error?.response?.data?.error?.message);
            }
        }
    };

    const handleContacts = async (checked) => {
        try {
            const { data } = await TurnOnOffMobileNoOfIBTreeApi({ onOffMobileNo: checked });
            if (data?.success) {
                setContactChecked(checked);
                toast.success(data?.message);
            }
        } catch (error) {
            if (error?.response?.data?.error?.messag) {
                toast.error(error?.response?.data?.error?.message);
            }
        }
    }

    const getMaintenanceStatus = async () => {
        try {
            const { data } = await GetMaintenanceStatusApi();
            if (data?.success) {
                setChecked(data?.data);
            }
        } catch (error) { }
    }

    const getContactStatus = async () => {
        try {
            const { data } = await GetContactStatusApi();
            if (data?.success) {
                setContactChecked(data?.data?.isVisible);
            }
        } catch (error) { }
    }

    const handleParentChange = async (checked) => {
        try {
            const { data } = await UpdateParentVisibilityApi(userDetails?._id, new URLSearchParams({ status: checked }).toString());
            if (data?.success) {
                setParentChecked(checked);
                toast.success(data?.message);
            }
        } catch (error) {
            if (error?.response?.data?.error?.messag) {
                toast.error(error?.response?.data?.error?.message);
            }
        }
    }

    useEffect(() => {
        const stored = localStorage.getItem("verifyWithOpt");
        if (stored !== null) {
            setVerifyWithOpt(JSON.parse(stored));
        }
    }, []);

    useEffect(() => {
        if (isOpen2FAModal) {
            setTimer(120);
            if (intervalId) {
                clearInterval(intervalId);
            }

            const id = setInterval(() => {
                setTimer(current => {
                    if (current <= 1) {
                        clearInterval(id);
                        return 0;
                    }
                    return current - 1;
                });
            }, 1000);

            setIntervalId(id);
        }

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
                setIntervalId(null);
            }
        };
    }, [isOpen2FAModal]);

    useEffect(() => {
        if (timer <= 0) return;

        const id = setInterval(() => {
            setTimer(prev => {
                if (prev <= 1) {
                    clearInterval(id);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        setIntervalId(id);

        // Clean up when component unmounts or timer is reset
        return () => clearInterval(id);
    }, [timer]);


    const resendOTPHandler = async (values) => {
        try {
          const { data } = await Request2faChangeApi(values);
          if (data?.success) {
            toast.success(data?.message);
            return true;
          }
        } catch (err) {
          console.error(err);
        }
        return false;
      };


    const open2FAHandle = async () => {
        setLoading(true);
        const success = await resendOTPHandler(!verifyWithOpt);
        setLoading(false);
        if (success) {
            formotp.resetFields();
            setTimer(120);
            setIsOpen2FAModal(true);
        }
    };

    const handleSubmit2FA = async (values) => {
        const { otp } = values;

        if (!otp) {
            toast.error("OTP can not be empty.");
            return;
        }

        try {
            setIsLoading(true);
            let params = {
                userId: userDetails?._id,
                Otp: otp,
                isActiveFlag: !verifyWithOpt,
            };
            const { data } = await ForgetOtp2FAApi(params);

            if (data?.success) {
                toast.success(data?.message);
                const newValue = !verifyWithOpt;
                setVerifyWithOpt(newValue);
                localStorage.setItem("verifyWithOpt", JSON.stringify(newValue));
                formotp.resetFields();
                setIsOpen2FAModal(false);
            }

            setIsLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.message || "Something went wrong");
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getContactStatus();
        getMaintenanceStatus();
    }, []);

    const onChange = (e) => {
        const newValue = e.target ? e.target.value : e;
        setFormData({ ...FormData, otp: newValue });
    };
    const sharedProps = {
        onChange,
    };

    return (
        <div>
            <div className='border rounded-lg flex justify-between items-start p-5'>
                <div className='flex items-center'>
                    <Avatar round size={60} src={userDetails?.profileImage} />
                    <div className='ml-4'>
                        <p className='font-medium text-lg'>{userDetails?.fullName}</p>
                        <p className='text-[#848484] text-lg mt-1'>{userDetails?.address}</p>
                    </div>
                </div>
            </div>

            <div className='border rounded-lg p-4 mt-4'>
                <p className='font-medium text-xl '>Personal Information</p>
                <div className='grid sm:grid-cols-2 grid-cols-1 mt-5 items-center gap-5'>
                    <div>
                        <p className='text-[#848484] font-normal text-base '>First Name</p>
                        <p className='text-[#848484] font-semibold text-base mt-1'>{userDetails?.firstName}</p>
                    </div>
                    <div className=''>
                        <p className='text-[#848484] font-normal text-base '>Lat Name</p>
                        <p className='text-[#848484] font-semibold text-base mt-1'>{userDetails?.lastName}</p>
                    </div>
                    <div>
                        <p className='text-[#848484] font-normal text-base '>Email Address</p>
                        <p className='text-[#848484] font-semibold text-base mt-1'>{userDetails?.email}</p>
                    </div>
                </div>
            </div>

            {(isAdmin && !isSalesManager) &&
                <div>
                    <div className='flex items-center border rounded-lg p-4 mt-4'>
                        <Switch
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            checked={checked}
                            onChange={handleChange}
                        />
                        <p className='text-[#848484] font-semibold text-base ms-2'>Maintenance Mode</p>
                    </div>

                    <div className='flex items-center border rounded-lg p-4 mt-4'>
                        <Switch
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            checked={contactChecked}
                            onChange={handleContacts}
                        />
                        <p className='text-[#848484] font-semibold text-base ms-2'>Show Contacts</p>
                    </div>

                    <div className='flex items-center border rounded-lg p-4 mt-4'>
                        <Switch checkedChildren="ON" unCheckedChildren="OFF" checked={parentChecked} onChange={handleParentChange} />
                        <p className='text-[#848484] font-semibold text-base ms-2'>Visible as Parent</p>
                    </div>
                    <div className='flex items-center border rounded-lg p-4 mt-4'>
                        <Switch
                            checkedChildren="ON"
                            unCheckedChildren="OFF"
                            checked={verifyWithOpt}
                            loading={loading}
                            onClick={open2FAHandle}
                        />
                        <p className='text-[#848484] font-semibold text-base ms-2'>Two Factor Authentication (2FA)</p>
                    </div>
                </div>
            }
            <ModalComponent isOpen={isOpen2FAModal} setIsOpen={setIsOpen2FAModal} title='Two Factor Authentication' width={600}>
                <div className='sm:grid grid-cols-12 justify-center items-center '>
                    <div className='md:col-span-12 col-span-5 flex flex-col bg-[#FFFFFF] justify-center items-center px-10 py-10 gap-6  w-full'>

                        <div className="text-center">
                            <p className="text-[#da3a3a] text-sm font-medium auth-com mt-2">
                                A verification code has been sent to your email address: {userDetails?.email}
                            </p>
                            <p className="text-[silver] text-sm font-medium auth-com mt-2  ">
                                Please enter the OTP and verify yourself
                            </p>
                        </div>
                        <div className="w-full">
                            <Form autoComplete="off" form={formotp} onFinish={handleSubmit2FA}>
                                <div className="w-full text-sm py-1">
                                    <div className="relative">
                                        <Form.Item
                                            name="otp"
                                            rules={[
                                                {
                                                    required: true,
                                                },
                                            ]}
                                        >
                                            <Input.OTP
                                                {...sharedProps}
                                                style={{ width: '100%' }}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                                <div className="my-6 flex justify-center">
                                    {
                                        timer == 0 ? (<button type="button" onClick={open2FAHandle} className="text-sm primary font-bold"><span className="text-black font-normal">Didn't receive it?</span> Resend OTP</button>) : (<p>Resend OTP in {formatTime(timer)}</p>)
                                    }
                                </div>
                                <div className="mt-8">
                                    <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Verify' isLoading={isLoading} loadingLable='Verifying...' />
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </ModalComponent>
        </div>
    )
}